import { Divider } from '@hover/blueprint';
import React, { useContext } from 'react';

import type {
  FeatureCategories,
  ShapeFilterItemType,
} from 'src/modules/designStudio/constants';
import { ShapesFilterItems, Types } from 'src/modules/designStudio/constants';
import type { MenuItemType } from 'src/modules/designStudio/constants/hardCodedData/textureData';
import { productCatalogContext } from 'src/modules/designStudio/providers';
import type { UpdateDesignFunction } from 'src/modules/designStudio/providers/HistoryProvider';
import type { Color } from 'src/modules/designStudio/types';
import { useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';

import { ThumbnailList } from '../../ThumbnailList';

const FILTER_TITLE = 'Shapes';

export const ShapeFilter = ({
  previousColor,
  selectedMenuItem,
  updateDesign,
}: {
  previousColor: Color;
  selectedMenuItem?: MenuItemType;
  updateDesign: UpdateDesignFunction;
}) => {
  const t = useTranslate(TranslationNamespace.DESIGN_STUDIO);
  const { menuItems } = useContext(productCatalogContext);

  if (!selectedMenuItem || !(selectedMenuItem.type === Types.SHINGLED_SIDING))
    return null;

  const onClick = (shape: string) => {
    const selectedTexture = menuItems.find(
      item =>
        item.shape === shape && item.category === selectedMenuItem.category,
    );

    if (!selectedTexture) return;

    updateDesign({
      selectedTexture,
      category: selectedMenuItem.category as FeatureCategories,
      update: {
        textureId: selectedTexture.textureId,
        color: previousColor,
      },
      trackingData: {
        parameter: FILTER_TITLE,
        product: selectedMenuItem.category,
        selection: selectedTexture.textureId,
      },
    });
  };

  const shapes = new Set<ShapeFilterItemType>();

  menuItems.forEach(item => {
    if (item.category === selectedMenuItem.category) {
      const shapeItem = ShapesFilterItems.find(
        shapeFilterItem => shapeFilterItem.id === item.shape,
      );

      if (shapeItem) shapes.add(shapeItem);
    }
  });

  const selectedId = selectedMenuItem.shape;
  const items = Array.from(shapes);

  return (
    <>
      <ThumbnailList
        items={items}
        onClick={onClick}
        selectedId={selectedId}
        title={t('menu.filters.shape')}
      />
      <Divider orientation="horizontal" />
    </>
  );
};
